import(/* webpackMode: "eager" */ "/home/ucraft/ucraft-next/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ucraft/ucraft-next/src/components/pages/SinglePageApp/singlePageApp.tsx");
